<template>
    <div>
        <v-container v-if='!initLoading'>
            <v-row>
                <v-col cols='12' md='7'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>دستگاه‌های متصل</h3>
                    <InfoAlert>
                     <span>در صورتی که تمایل دارید دسترسی به حساب خود را از دستگاه‌های متصل حذف کنید، ابتدا دستگاه‌های مورد نظر را انتخاب کنید</span>
                        <template slot='action'>
                            <v-btn
                                :block='$vuetify.breakpoint.smAndDown'
                                class='mb-2 mb-md-0'
                                    name='Add_Apartment'
                                    color='error'
                                    :disabled="selectedTokens.length===0"
                                    @click='logoutFromTokenDialog = true'
                            >
                                <span>خروج از حساب های انتخاب شده</span>
                            </v-btn>
                        </template>
                    </InfoAlert>
                </v-col>
                <v-col  cols='12' md='7'>
                    <v-simple-table>
                        <thead>
                        <tr>
                            <th>
                                <v-menu transition="scale-transition"
                                        origin="center center">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <div>
                                                <v-icon size='24px'>
                                                    mdi-dots-vertical
                                                </v-icon>
                                            </div>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item link
                                        >
                                            <v-list-item-title></v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </th>
                            <th class='text--disabled'>ip</th>
                            <th class='text--disabled'>دستگاه</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for='item in activity' :key='item._id' :for="item._id">
                            <td>
                                <v-checkbox v-model="selectedTokens" :value="item._id" :id="item._id"></v-checkbox>
                            </td>
                            <td>
                                <div>{{ item.host }}
                                    <v-chip small color="info" class="mr-2" v-if="item.token === token.replace('Bearer ','')">
                                        دستگاه شما
                                    </v-chip>
                                </div>

                            </td>
                            <td v-if='item.userAgent'>
                                <div>
                                    <span v-if=' item.userAgent.isMobile'>موبایل</span>
                                    <span v-else>رایانه</span>
                                </div>
                                <div>
                                    {{ item.userAgent.platform }}
                                </div>
                                <div>
                                    {{ item.userAgent.browser }}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>


        </v-container>

        <v-dialog v-model='logoutFromTokenDialog' max-width='420' persistent>
            <v-card v-if='!submitVerifyCodeForm'>
                <v-card-title>خروج از حساب‌های انتخاب شده</v-card-title>
                <v-card-text>
                    با تایید شما، خروج از حساب کاربری از این دستگاه‌ها انجام میشود. آیا مطمئن هستید؟
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-btn
                            color='primary'
                            :loading='loadingLogoutFromTokenRequest'
                            @click='logoutToken'
                    >
                        تایید
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                            outlined
                            @click='logoutFromTokenDialog = false'
                    >
                        انصراف
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-else>
                <v-card-title class='subtitle-1'>ارسال کد تایید خروج از حساب متصل</v-card-title>
                <v-card-text class='ltr'>
                    <v-otp-input
                            autofocus
                            :disabled='loadingSubmitCode'
                            v-model='code'
                            length='6'
                            type='number'
                            @finish='submitVerifyLogoutFromToken'
                    ></v-otp-input>
                    <v-overlay absolute :value='loadingSubmitCode'>
                        <v-progress-circular
                                indeterminate
                                color='primary'
                        ></v-progress-circular>
                    </v-overlay>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            outlined
                            @click='closeLogoutFromTokenDialog'
                    >
                        انصراف
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import {mapActions, mapState} from 'vuex';
    import InfoAlert from '@/components/Alerts/InfoAlert';

    export default {
        name: 'ActiveDevices',
        components: { InfoAlert },
        data: () => ({
            selectedTokens: [],
            activity: [],
            code: null,

            submitVerifyCodeForm: false,
            logoutFromTokenDialog: false,
            loadingSubmitCode: false,
            loadingLogoutFromTokenRequest: false,

            initLoading: true,
            loadingLogout: false
        }),
        methods: {
            closeLogoutFromTokenDialog() {
                this.logoutFromTokenDialog = false;
                this.submitVerifyCodeForm = false;
            },
            // verify logout form token
            async submitVerifyLogoutFromToken() {
                this.loadingSubmitCode = true;
                await axios
                    .post(`/api/users/me/tokens/selectedTokens/verify_logout`, {
                        code: this.code,
                        tokens_id: this.selectedTokens
                    })
                    .then(res => {
                        this.activity = res.data.activity.reverse();
                        this.code = null;
                        this.submitVerifyCodeForm = false;
                        this.logoutFromTokenDialog = false;
                        this.$snackbar.showMessage({
                            color: 'success',
                            timeout: 3000,
                            content: 'خروج از حساب کاربری متصل انجام شد'
                        });
                    })
                    .catch(err => {
                        console.error(err);

                        let content = `خطا در سرور \n ${err.response ? err.response.data.error : ''}`;
                        if (err.response && err.response.status === 403) content = 'کد وارد شده صحیح نمیباشد';
                        this.code = null;
                        this.$snackbar.showMessage({
                            color: 'red',
                            timeout: 5000,
                            content
                        });
                    });
                this.loadingSubmitCode = false;
            },
            async logoutToken() {
                this.loadingLogoutFromTokenRequest = true;
                await axios
                    .get(`/api/users/me/tokens/selectedTokens/logout`)
                    .then(() => {
                        this.$snackbar.showMessage({
                            color: 'success',
                            timeout: 3000,
                            content: 'کد تایید خروج از حساب کاربری به شماره تلفن همراه شما ارسال شد'
                        });
                        this.submitVerifyCodeForm = true;
                    })
                    .catch(err => {
                        console.error(err);
                        let content = `خطا در سرور \n ${err.response ? err.response.data.error : ''}`;

                        this.$snackbar.showMessage({
                            color: 'red',
                            timeout: 7000,
                            content
                        });
                    });
                this.loadingLogoutFromTokenRequest = false;
            },
            async fetchUserActivity() {
                await axios
                    .get('/api/users/me/activity')
                    .then(res => {
                        this.activity = res.data.activity.reverse();
                    })
                    .catch(err => {
                        console.error(err);
                        let content = `خطا در سرور \n ${err.response ? err.response.data.error : ''}`;

                        if (err.response.status === 401) {
                            content = 'نیاز به ورود مجدد به حساب';
                            this.$router.push({name: 'Login'});
                        }
                        this.$snackbar.showMessage({
                            color: 'red',
                            timeout: 3000,
                            content
                        });
                    });
            },
            ...mapActions([
                'showNavigation', 'setToken', 'setUser',  'showBreadCrumbs', 'setBreadCrumbsTemp'
            ])
        },
        computed: {
            ...mapState(['token'])
        },
        async created() {
            this.initLoading = true;

            await this.fetchUserActivity();


            let href = window.location.pathname + window.location.search;
            await this.setBreadCrumbsTemp({
                key: 'activeDevices',
                value: {
                    text: `دستگاه‌های متصل`,
                    href: href
                }
            });
            this.initLoading = false;
        },
        async updated() {
            await this.showBreadCrumbs(['profile','activeDevices']);
        },
    };
</script>

<style scoped>

</style>